/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_TypicalInputs */

const en_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typical (p50)`)
};

const zh_hans1_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`典型值（p50）`)
};

const pt_br2_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Típico (p50)`)
};

const es_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Típico (p50)`)
};

const fr_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typique (p50)`)
};

const de_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typisch (p50)`)
};

const ru_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типичное (p50)`)
};

const it_measure_latency_typical = /** @type {(inputs: Measure_Latency_TypicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipico (p50)`)
};

/**
* | output |
* | --- |
* | "Typical (p50)" |
*
* @param {Measure_Latency_TypicalInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_typical = /** @type {((inputs?: Measure_Latency_TypicalInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_TypicalInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_typical(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_typical(inputs)
	if (locale === "es") return es_measure_latency_typical(inputs)
	if (locale === "fr") return fr_measure_latency_typical(inputs)
	if (locale === "de") return de_measure_latency_typical(inputs)
	if (locale === "ru") return ru_measure_latency_typical(inputs)
	if (locale === "it") return it_measure_latency_typical(inputs)
	return en_measure_latency_typical(inputs)
});